import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { ACCOUNTS_QUERY_KEY } from "./useAccounts";

type CreateAccountBody = components["schemas"]["CreateAccountBody"];
type AccountResponse = components["schemas"]["AccountResponse"];

export function useCreateAccount() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<AccountResponse, Error, CreateAccountBody>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/accounts", { body });
      if (error !== undefined) {
        throw new Error("Failed to create account");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ACCOUNTS_QUERY_KEY });
    },
  });
}
